import React from 'react';
import { StyledDivider } from './Divider.styles';

const Divider = ({ heading, children, ...rest }) => {
    return (
        <StyledDivider { ...rest}/>
    )
}

export default Divider;